import { writeStoredZoom } from '../utils/zoom';

// Zoom par-utilisateur (cf. utils/zoom.js) : champ runtime-only, source de
// vérité localStorage, jamais synchronisé ni persisté dans le document.
export const zoomActions = (set) => ({
  setZoom: (value) => {
    if (value != null && (value < 24 || value > 500)) return;
    writeStoredZoom(value);
    set({ zoomLevel: value }, false, `Set zoom ${value}`);
  },
  // canScrollX : mesuré par Middle.jsx (scrollWidth > clientWidth de #pdf),
  // pilote l'affichage du bouton main dans ZoomControl. panModeActive : suit
  // le bouton main, jamais actif si canScrollX repasse à false (cf. effet
  // dans Middle.jsx qui le reset).
  setCanScrollX: (value) => set({ canScrollX: value }, false, 'Set canScrollX'),
  togglePanMode: () => set((state) => ({ panModeActive: !state.panModeActive }), false, 'Toggle panMode'),
  setPanModeActive: (value) => set({ panModeActive: value }, false, 'Set panModeActive'),
});
